import { Timestamp } from 'firebase/firestore'

import { BeachAsset } from '../features/BeachPlan/jotai-modules/types'

export const MAX_BEACH_PLANS = 4

export type BeachPlanSpotIconMaxWidths = {
  facilities: number
  cabana: number
  umbrella: number
  pouf: number
}

export interface BeachPlanDocument {
  name: string
  displayOrder: number
  isDefault: boolean
  isEnabled: boolean
  rows: number
  columns: number
  background: string
  spots: BeachAsset[]
  spotIconMaxWidths?: BeachPlanSpotIconMaxWidths
  updatedAt?: Timestamp
}

export interface BeachPlanFirestoreData extends BeachPlanDocument {
  id: string
}

export type BeachPlanSpotWithPlan = BeachAsset & {
  beachPlanId: string
  beachPlanName: string
}
